import { v4 as uuidv4 } from "uuid";
export default class ProjectionAssignation {
  firstName: string;
  lastName: string;
  userExternalId: string;
  roleType: string;
  externalHours: number;
  bonusHours: number;
  shadow: boolean;
  projectName: string;
  externalId: string;

  constructor(
    projectName: string,
    firstName: string = "",
    lastName: string = "",
    userExternalId: string = "",
    roleType: string = "",
    externalHours: number = 0,
    bonusHours: number = 0,
    shadow: boolean = false,
    externalId: string = ""
  ) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.userExternalId = userExternalId;
    this.roleType = roleType;
    this.externalHours = externalHours;
    this.bonusHours = bonusHours;
    this.shadow = shadow;
    this.projectName = projectName;
    this.externalId = externalId.length > 0 ? externalId : `${uuidv4()}`;
  }

  public isFullBilled() {
    return this.bonusHours === 0 && !this.shadow;
  }
}
